export const urlExp = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
// export const alphanumericExp = /^\S*(([A-za-z]\S*[0-9])|([0-9]\S*[A-Za-z]))+\S*$/;
// export const alphaOrNumericExp = /^[A-Z0-9_]+$/;
// export const alphaOrHangulExp = /^[A-Za-z가-힣]+$/;
// export const amountWithoutZeroExp = /^-?([1-9][0-9]{0,5}|1000000)$/;
// export const cardNumberExp = /^\d{4}\d{2}\*{2}\*{3,4}\d{0,4}$/;
// export const enterpriseRegistrationNumberExp = /^\d{10}$/;
// export const lowerOrNumericExp = /^[a-z0-9_]+$/;
// export const nonRepeatableFourCharatersExp = /^(?!.*(.)\1{3,}).+$/;
// export const notEqualToZero = /[^0]+/;
// export const numericExp = /^[0-9]*$/;
// export const numericWithOneDecimalPointExp = /^-?(\d{1,3}([.]\d{0,1})?)?$/;
// export const numericWithTwoDecimalPointsExp = /^-?(\d{1,3}([.]\d{0,2})?)?$/;
// export const timeExp = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
// export const timeHMExp = /^((([01][0-9]|2[0-3]):[0-5][0-9])|24:00){1}$/;
